import { KeyboardNavigationHelper } from "@components/ui/KeyboardNavigatorHelper"
import { TooltipProvider } from "@components/ui/Tooltip"
import { AlertSystem } from "@features/alerts/alerts"
import { CartExpiryWarnings } from "@features/ferve/CartExpiryWarnings"
import { FerveProvider } from "@features/ferve/FerveProvider"
import { TicketModalSystem } from "@features/ferve/tickets-modal"
import { FlyingCarpet } from "@features/flying-carpet/FlyingCarpet"
import { Header } from "@features/header/Header"
import { SiteTheme } from "@features/header/header-theme"
import { NewsletterPopup } from "@features/newsletter/NewsletterPopup"
import { RouteDrawer } from "@features/routes/DrawerRouteDisplay"
import { ThemedRouteDisplay } from "@features/routes/ThemedRouteDisplay"
import { useRoutesDisplay } from "@features/routes/useRoutesDisplay"
import { LinkTracking } from "@features/tracking/LinkTracking"
import { WishlistModals } from "@features/wishlist/WishlistSelectModal"
import { usePageByUri } from "@hooks/queries"
import { defineView } from "eddev/views"
import { AnimatePresence, useAnimationFrame } from "motion/react"
import { useLayoutEffect } from "react"

import { SearchManager } from "@features/search/SearchManager"
import "@features/tracking/tracking"
import { AcknowledgementOverlay } from "@features/acknowledgement/AcknowledgementOverlay"

export default defineView("_app", (props) => {
  const { mainRoute, drawerRoutes } = useRoutesDisplay()

  return (
    <FerveProvider>
      <TooltipProvider>
        <SiteTheme route={mainRoute}>
          {/* UI */}
          <Header />
          <FlyingCarpet />
          {/* <AcknowledgementOverlay /> */}

          {/* Main route contents */}
          <ThemedRouteDisplay route={mainRoute} isMain />

          {/* Drawer routes, if any */}
          <AnimatePresence>
            {drawerRoutes?.map((route) => <RouteDrawer route={route} key={route.id} />)}
          </AnimatePresence>

          {/* Systems */}
          <SearchManager />
          <LinkTracking />
          <KeyboardNavigationHelper />
          <AlertSystem />
          <TicketModalSystem />
          <CartExpiryWarnings />
          <WishlistModals />
          <ViewportStyles />
          {/* <ViewportDebugger /> */}
        </SiteTheme>
        <NewsletterPopup />
      </TooltipProvider>
    </FerveProvider>
  )
})

if (env.client) {
  // @ts-ignore
  window.fetchPageByUri = (uri: string) => {
    return usePageByUri.fetch({
      uri: uri,
    })
  }
}

/**
 * Add --scrollbar-width to the html element
 */
function ViewportStyles() {
  if (env.client) {
    useLayoutEffect(() => {
      if (!document.scrollingElement) return
      const updateScrollbarWidth = () => {
        const scrollbarWidth = window.innerWidth - document.scrollingElement!.clientWidth
        document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`)
      }

      updateScrollbarWidth()

      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", updateScrollbarWidth)
        return () => {
          window.visualViewport?.removeEventListener("resize", updateScrollbarWidth)
        }
      } else {
        window.addEventListener("resize", updateScrollbarWidth)
        return () => {
          window.removeEventListener("resize", updateScrollbarWidth)
        }
      }
    }, [])

    useAnimationFrame(() => {
      if (window.visualViewport) {
        document.documentElement.style.setProperty(
          "--visual-viewport-height",
          `${window.visualViewport.height * window.visualViewport.scale}px`,
        )
      }
    })
  }

  return null
}
